export const BASE_API_URL = 'http://13.233.236.54:8051'
    // export const BASE_API_URL = '//businessbe.money91.com';
export const FILE_UPLOAD_URL = 'https://media.getzyk.com/uploadMediaFile/6'